module.exports = __webpack_public_path__ + "img/enterprise_bg1.099d8f53.png";